export default __webpack_public_path__ + "static/media/Acutus.4eb5ad7d.jpg";